import { render, staticRenderFns } from "./MarkMidtermTest.vue?vue&type=template&id=6bc6d5b6&scoped=true"
import script from "./MarkMidtermTest.vue?vue&type=script&lang=js"
export * from "./MarkMidtermTest.vue?vue&type=script&lang=js"
import style0 from "./MarkMidtermTest.vue?vue&type=style&index=0&id=6bc6d5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6d5b6",
  null
  
)

export default component.exports